import React, { useState } from "react";
import Select from "react-select";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import "./Contact.css";
import axios from "axios";
function Contact() {
  const [loading, setLoading] = useState(false);
const [errors, setErrors] = useState({});
const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    country: "",
    address: "",
    projectTypes: [],
    message: "",
    file: null,
  });

  /* COUNTRIES */

  const countries = [
    { value: "Tunisie", label: "Tunisie" },
    { value: "France", label: "France" },
    { value: "Algérie", label: "Algérie" },
    { value: "Maroc", label: "Maroc" },
    { value: "Belgique", label: "Belgique" },
    { value: "Canada", label: "Canada" },
    { value: "Suisse", label: "Suisse" },
    { value: "Allemagne", label: "Allemagne" },
    { value: "Italie", label: "Italie" },
  ];

  /* PROJECT TYPES */

  const projectOptions = [
    "Cuisine",
    "Dressing",
    "Buanderie",
    "Agencement complet",
    "Autre",
  ];

  /* INPUT CHANGE */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* CHECKBOX */

  const handleCheckbox = (option) => {
    const updatedProjects = formData.projectTypes.includes(option)
      ? formData.projectTypes.filter((item) => item !== option)
      : [...formData.projectTypes, option];

    setFormData((prev) => ({
      ...prev,
      projectTypes: updatedProjects,
    }));
  };




  /* SUBMIT */

  const handleSubmit = async (e) => {
  e.preventDefault();

  let newErrors = {};

  /* VALIDATION */

  if (!formData.fullname.trim()) {
    newErrors.fullname = "Le nom est obligatoire";
  }

  if (!formData.phone.trim()) {
    newErrors.phone =
      "Le numéro de téléphone est obligatoire";
  }

  if (!formData.email.trim()) {
    newErrors.email =
      "L'adresse e-mail est obligatoire";
  }

  if (!formData.country.trim()) {
    newErrors.country = "Le pays est obligatoire";
  }

  if (!formData.message.trim()) {
    newErrors.message = "Le message est obligatoire";
  }

  if (formData.projectTypes.length === 0) {
    newErrors.projectTypes =
      "Sélectionnez au moins un projet";
  }

  /* STOP */

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setErrors({});

 try {
  setLoading(true);

  const formDataToSend = new FormData();

  formDataToSend.append("fullname", formData.fullname);
  formDataToSend.append("phone", formData.phone);
  formDataToSend.append("email", formData.email);
  formDataToSend.append("country", formData.country);
  formDataToSend.append("address", formData.address);

  formDataToSend.append(
    "projectTypes",
    formData.projectTypes.join(", ")
  );

  formDataToSend.append("message", formData.message);

  if (formData.file) {
    formDataToSend.append("file", formData.file);
  }

  const response = await axios.post(
    "https://elements-backend.vercel.app/api/send-email",
    formDataToSend,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  if (response.status === 200) {
    setSuccessMessage(
      "Votre demande a été envoyée avec succès."
    );

    setFormData({
      fullname: "",
      phone: "",
      email: "",
      country: "",
      address: "",
      projectTypes: [],
      message: "",
      file: null,
    });

    setErrors({});
  }
} catch (error) {
  console.log(error);

  console.log(error.response);

  alert("Une erreur est survenue");
} finally {
  setLoading(false);
}}
  return (
    <div className="contact-container">
      {/* LEFT SIDE */}

      <div className="contact-image">
        <div className="overlay">
          <h1>Créons Votre Projet Ensemble</h1>

          <p>
            Cuisine, dressing, aménagement intérieur ou projet sur
            mesure, contactez-nous dès maintenant.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE */}

      <div className="contact-form-wrapper">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Contactez-nous</h2>

          {/* FULLNAME */}

          <div className="input-group">
            <label>
              Nom et prénom <span>*</span>
            </label>

            <input
              type="text"
              name="fullname"
              value={formData.fullname}
              onChange={handleChange}
              required
            />
            {errors.fullname && (
    <p className="error-text">
      {errors.fullname}
    </p>
  )}
          </div>

          {/* PHONE */}

          <div className="input-group">
            <label>
              Numéro de téléphone <span>*</span>
            </label>

            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              pattern="[0-9+ ]{8,15}"
              required
            />
            {errors.phone && (
  <p className="error-text">
    {errors.phone}
  </p>
)}
          </div>

          {/* EMAIL */}

          <div className="input-group">
            <label>
              Adresse e-mail <span>*</span>
            </label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && (
  <p className="error-text">
    {errors.email}
  </p>
)}
          </div>

          {/* COUNTRY */}

        <Select
  className="react-select-container"
  classNamePrefix="react-select"
  options={countries}
  placeholder="Choisir un pays"
  value={
    countries.find(
      (country) => country.value === formData.country
    ) || null
  }
  onChange={(selectedOption) =>
    setFormData((prev) => ({
      ...prev,
      country: selectedOption.value,
    }))
  }
/>
          {/* ADDRESS */}

          <div className="input-group">
            <label>Adresse</label>

            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>

          {/* PROJECT TYPES */}

          <div className="project-section">
            <h3>
              Type de projet <span>*</span>
            </h3>

            <div className="checkbox-group">
              {projectOptions.map((option, index) => (
                <label
                  key={index}
                  className={`checkbox-item ${
                    formData.projectTypes.includes(option)
                      ? "active"
                      : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={formData.projectTypes.includes(
                      option
                    )}
                    onChange={() =>
                      handleCheckbox(option)
                    }
                  />

                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          {/* MESSAGE */}

          <div className="input-group">
            <label>
              Message <span>*</span>
            </label>

            <textarea
              name="message"
              rows="6"
              placeholder="Décrivez votre projet..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          {/* FILE */}

       <div className="file-upload">
  <label className="file-label">
    <AttachFileIcon />
    <span>
      {formData.file
        ? "Changer le fichier"
        : "Ajouter une pièce jointe"}
    </span>

    <input
      type="file"
      className="file-input"
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          file: e.target.files[0],
        }))
      }
    />
  </label>

  {formData.file && (
    <div className="file-name">
      {formData.file.name}
    </div>
  )}
</div>

          {/* BUTTON */}

          <button type="submit" disabled={loading}>
            {loading
              ? "Envoi en cours..."
              : "Envoyer la demande"}
          </button>
          {successMessage && (
  <div className="success-message">
    {successMessage}
  </div>
)}
        </form>
      </div>
    </div>
  );
}

export default Contact;